/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTeamBody
 */
export interface UpdateTeamBody {
    /**
     * New team name (3-32 characters)
     * @type {string}
     * @memberof UpdateTeamBody
     */
    name?: string;
    /**
     * Team abbreviation (2-6 characters)
     * @type {string}
     * @memberof UpdateTeamBody
     */
    tag?: string;
    /**
     * Asset ID for team logo
     * @type {string}
     * @memberof UpdateTeamBody
     */
    logoId?: string;
}

/**
 * Check if a given object implements the UpdateTeamBody interface.
 */
export function instanceOfUpdateTeamBody(value: object): value is UpdateTeamBody {
    return true;
}

export function UpdateTeamBodyFromJSON(json: any): UpdateTeamBody {
    return UpdateTeamBodyFromJSONTyped(json, false);
}

export function UpdateTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'logoId': json['logoId'] == null ? undefined : json['logoId'],
    };
}

export function UpdateTeamBodyToJSON(json: any): UpdateTeamBody {
    return UpdateTeamBodyToJSONTyped(json, false);
}

export function UpdateTeamBodyToJSONTyped(value?: UpdateTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'tag': value['tag'],
        'logoId': value['logoId'],
    };
}

